// extracted by mini-css-extract-plugin
module.exports = {"root":"MarkdownTextArea_root__1QkG2","markdownPreview":"MarkdownTextArea_markdownPreview__1t4Nk","markdownInput":"MarkdownTextArea_markdownInput__1ywZQ"};